// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/module/chart/chartCtrl.js#1 $
'use strict';

/**
* @ngdoc controller
* @name tcApp.controllers:ChartCtrl
* @description
* Chart controller.
*
*/

angular.module('tcApp')
.value('chartData', null)
.controller('ChartCtrl', function($document, $scope, $routeParams, $window, $location, $route,
									$timeout, $mdMedia, $mdDialog, $mdUtil, $sce, $q, $rootScope,
									chartData, GlobalService, WorkflowService, SystemRouter,
									ElementStateService, RouteParamsCache, tcConstants, LegacyScopeService) {
	
	var legacyFunctions = LegacyScopeService.getLegacyFunctions($scope);
	var tkMakeServerCall = legacyFunctions.tkMakeServerCall;

	var initialiseCtrl = function(chartData) {
		if (chartData != null) {
			$scope.data = chartData.data;
		}
		if (angular.isUndefined($scope.data)) $scope.data = {};
		if (!angular.isObject($scope.options)) $scope.options = {};
		$scope.globalStrings = GlobalService.getGlobalStrings();
		$scope.viewModel = {
			// Add chartUniqueIndex as per component ?
			chartHtmlName: 'tc_Chart',
			allowChartMenu: allowChartMenu(),
			chartMenuHidden: (ElementStateService.getPersistant('tcChartbookToggledState') == 'chartMenuHidden'),
			chartMenuToggled: false,
			searchText: '',
			sections: [],
			timers: [],
		};
		
		if ($mdMedia('xs')) {
			$scope.viewModel.chartMenuHidden = true;
		} else if (angular.isDefined(ElementStateService.getPersistant('tcChartbookToggledState'))) {
			$scope.viewModel.chartMenuHidden = 
				(ElementStateService.getPersistant('tcChartbookToggledState') == 'chartMenuHidden');
			$scope.viewModel.chartMenuToggled = !$scope.viewModel.chartMenuHidden;
		} else if ($mdMedia('sm') || $mdMedia('md')) {
			$scope.viewModel.chartMenuHidden = true;
			ElementStateService.setPersistant('tcChartbookToggledState', 
			$scope.viewModel.chartMenuHidden ? 'chartMenuHidden' : '');
		}
		
		if ($scope.data.bannerData) GlobalService.updateBannerData($scope.data.bannerData);
		
		// fetch HasData values on next timer tick so that it doesn't block loading of component templates
		if (!$scope.data.hasDataLoaded) $scope.viewModel.timers.push($timeout(fetchHasData));

		if (($scope.data.charts) && (angular.isDefined($scope.data.selectedChart))) {
			var loadingPromises = [];
			var selectedChart = $scope.data.charts[$scope.data.selectedChart];
			var selectedChartItem = selectedChart.selectedChartItem;
			// If chartScrollItem exists use it as selected Chart Item
			var chartScrollItemIndex = ElementStateService.get('chartScrollItem', angular.toJson($route.current.params));
			if (chartScrollItemIndex) selectedChartItem = chartScrollItemIndex;		
			var displayInTabs = (selectedChart.displayInTabs != '');

			// If we only display a single item, load it first and then do hasData() requests
			if (displayInTabs) {
				$scope.data.selectedChartItem = selectedChartItem;
				var selectedChartItemObject = selectedChart.items[selectedChartItem];
				if (selectedChartItemObject && !selectedChartItemObject.skipItem) {
					loadingPromises.push(
						loadChartItemData(
							selectedChartItemObject, selectedChartItemObject.chartItemIndex, false
					));
				}
			}
			
			angular.forEach(selectedChart.items, function(item) {
				if (!item.skipItem) loadingPromises.push(loadChartItemData(item, item.chartItemIndex, displayInTabs));
			});
			
			if (loadingPromises.length > 0) scrollAfterDataIsLoaded(loadingPromises);
			
			// For externally embedded pages, start activity monitor
			if (angular.isDefined(selectedChart)) {
				if (angular.isDefined(selectedChart.customUrl)) {
					$rootScope.$broadcast('SessionLockTimeout:startMonitor', selectedChart.customUrl);
				} else if ((angular.isDefined($scope.data.selectedChartItem))
						&& (angular.isDefined(selectedChart.items[$scope.data.selectedChartItem]))
						&& (angular.isDefined(selectedChart.items[$scope.data.selectedChartItem].customUrl))) {
					$rootScope.$broadcast('SessionLockTimeout:startMonitor',
										selectedChart.items[$scope.data.selectedChartItem].customUrl);
				}
			}
		}
		
		$document.ready(function() {
			if (($scope.data.charts) && angular.isDefined(selectedChartItem) && (selectedChartItem !== '')
				&& (selectedChartItem >= 0)) {
				$scope.data.selectedChartItem = parseInt(selectedChartItem);
			} else {
				$scope.data.selectedChartItem = 0;
			}
			scrollAndFocusChartMenu();
			
			if ($scope.data._isCached) {
				$scope.viewModel.timers.push($timeout(fetchBannerData));
			}
		});
		
		if ($scope.data.counters) GlobalService.updateCounters($scope.data.counters);
		if (angular.isDefined($scope.data.name)) {
			GlobalService.updateChartName($scope.data.name);
		} else if ((angular.isDefined($scope.data.charts)) && (angular.isDefined($scope.data.charts[0]))
			&& (angular.isDefined($scope.data.charts[0].name))) {
			GlobalService.updateChartName($scope.data.charts[0].name);
		}
		// If there was a security violation or other framework error, error.hideLayout will be 
		// set to True and we will not request a layout to prevent user from using an unauthorised layout
		if ($scope.data.error && $scope.data.error.hideLayout) {
			$scope.viewModel.templateUrl = 'template/component/componentError.html';
		}
		
		$scope.$watch('viewModel.searchText', applySearchText);
		
	};
	
	var fetchBannerData = function() {
		if (!$scope.data.patientId) return;
		GlobalService.getBanner($scope.data.patientId, $scope.data.episodeId);
	};
	
	//Use the search text from the "filter charts" input to hide/unhide matching charts
	var applySearchText = function() {
		angular.forEach($scope.data.charts, function(chart) {
			var searchText = $scope.viewModel.searchText.toLowerCase();
			var textLength = searchText.length;
			var selectedChart = $scope.data.charts[$scope.data.selectedChart];
			var selectedChartItem = selectedChart.selectedChartItem;

			if (textLength == 0) {
				if (chart != selectedChart) {
					chart.collapse = 1;
					chart.searchFilter = undefined;
					angular.forEach(chart.items, function(chartItem) {
						chartItem.searchFilter = undefined;
					});
				} else {
					chart.collapse = 0;
					chart.searchFilter = 0;
					angular.forEach(chart.items, function(chartItem) {
						if (chartItem != selectedChartItem) {
							chartItem.searchFilter = undefined;
						} else {
							chartItem.searchFilter = 0;
						}
					});
				}
			} else {
				var caption = chart.caption.toLowerCase();
				var chartSearchVal = caption.includes(searchText);
				
				if (!chartSearchVal) {
					if (chart != selectedChart) {
						chart.searchFilter = 1;
					}
				} else {
					chart.searchFilter = 0;
				}
			
				angular.forEach(chart.items, function(chartItem) {
					if ((chartItem !== '') && (angular.isDefined(chartItem.caption))) {
						var chartItemCaption = chartItem.caption.toLowerCase();
						var chartItemSearchVal = chartItemCaption.includes(searchText);
						if (chartItemSearchVal) {
							chartItem.searchFilter = 0;
							chart.searchFilter = 0;
							chart.collapse = 0;
						} else if ((chartItem.chartItemIndex != selectedChartItem) || (chart != selectedChart)) {
							chartItem.searchFilter = 1;
						}
					}
				});
			}
		});	
					
	};
	
	// Scroll to the selected chart or chart item menu
	var scrollAndFocusChartMenu = function() {
		if ((angular.isDefined($scope.data.selectedChart)) && (!$mdMedia('xs'))) {
			// For charts that hide chart tabs, allow longer for the DOM to update
			// Ideally the chart logic should be refactored
			var scrollFocusDelay = ($scope.data.hideIfNoData ? 500 : 100);
			$timeout(function() {
				scrollToChartMenu($scope.data.selectedChart, $scope.data.selectedChartItem);
				
				// focusFirst is not performed in this case due to possible scrolling, so we must manage focus here
				if (($route.current.params.chartItem)
					&& ($scope.data.selectedChartItem > 0)) {
					var focusElementId = '';
					if (!$scope.viewModel.chartMenuHidden) {
						focusElementId = 
							$scope.viewModel.chartHtmlName + '-menu-' + $scope.data.selectedChart
															+ '-item-' + $scope.data.selectedChartItem;	
					} else {
						focusElementId = $scope.viewModel.chartHtmlName + '-menuVertical';
					}
					var focusElement = $window.document.getElementById(focusElementId);
					if (focusElement) focusElement.focus();
				}
			}, scrollFocusDelay);
		}
	};

	var scrollAfterDataIsLoaded = function(loadingPromises) {
		$q.all(loadingPromises).then(function() {
			var scrollTop = ElementStateService.get('scrollTop', angular.toJson($routeParams));
			if ((angular.isDefined(scrollTop)) && (scrollTop > 0)) {
				$timeout(function() {
					GlobalService.scrollTop(scrollTop);
				});
			}
		});
	};
	
	var chartItemIsCompAlwaysReload = function(item) {
		if ((angular.isDefined(item.componentData)) && (item.componentData.componentAlwaysReload)) {
			return true;
		}
		return false;
	};
	
	var reloadCachedComponents = function(arrayOfReloadComponentNames) {
		for (var compHtmlName of arrayOfReloadComponentNames) {
			GlobalService.reloadComponent(compHtmlName, {skipBanner: true});
		}
	};

	// Recursively checks if a chart item or its child items need to be reloaded
	// because of the componentAlwaysReload flag
	// returns:
	//   false = no need to reload,
	//   true = all items need to reload, can reload the chart item (including where chart item is a list of chart items)
	//   array[] = at least one item needs to reload, but not all, array contains component html name for reloading individually.
	var checkReload = function(item) {
		if (chartItemIsCompAlwaysReload(item)) {
			return true;
		} else if (angular.isArray(item.items)) {
			// item is a chart, need to check for components to be reloaded
			var hasNonReloadItem = false;
			var reloadComponents = [];
			for (var nestedItem of item.items) {
				if (chartItemIsCompAlwaysReload(nestedItem)) {
					reloadComponents.push(nestedItem.componentData.componentParamPrefix);
				} else {
					hasNonReloadItem = true;
				}
			}
			if ((hasNonReloadItem) && (reloadComponents.length)) return reloadComponents;
			return (reloadComponents.length > 0);
		}
		return false;
	};
	
	var loadChartItemData = function(item, index, hasDataOnly) {
		if (item.dataLoaded) {
			var getNewData = false;
			// if chart item list component is defined with AlwaysReload, then always fetch new data
			if ((!hasDataOnly) && ($scope.data._isCached)) {
				getNewData = checkReload(item);
				if (angular.isArray(getNewData)) {
					// require a timeout as reloadComponent still thinks $scope is the page before the navBack
					$scope.viewModel.timers.push($timeout(reloadCachedComponents, 0, true, getNewData));
					return;
				}
			}
			if (!getNewData) return;
		}
		
		var listComponentUniqueIndex = item.listComponentUniqueIndex;
		var chartRouteParams = angular.extend({}, $routeParams);
		if (angular.isDefined(chartRouteParams.chartBookId) && angular.isDefined($scope.data.id)) {
			chartRouteParams.chartBookId = $scope.data.id;
		}
		// add any unique list specific parameters
		if (!hasDataOnly) {
		var cachedRouteParams = RouteParamsCache.get($location.url());
		if ((cachedRouteParams) && (angular.isDefined(cachedRouteParams.TUNIQUELISTPARAMS))) {
				angular.forEach(cachedRouteParams.TUNIQUELISTPARAMS, function(uniqueListParam) {
					angular.extend(chartRouteParams, uniqueListParam);
				});
			}
		}
		return SystemRouter.fetchChartItemData(
			$scope.data.charts[$scope.data.selectedChart].id, index, hasDataOnly, listComponentUniqueIndex, chartRouteParams)
			.then(function(response) {
				if (angular.isObject(response.data)) {
					if (angular.isDefined(response.data.error)) {
						$scope.data.error = response.data.error;
						return;
					}
					angular.extend(item, response.data);
					item.statusClass = getChartItemClass(item);

					var selectedChartItem = $scope.data.charts[$scope.data.selectedChart].items[$scope.data.selectedChartItem];

					if (item !== selectedChartItem) {
						item.hidden = item.shouldHide && ($scope.data.hideIfNoData || item.eprReadOnly);
					}
				}
			});
	};

	var fetchHasData = function() {
		
		var searchText = $scope.viewModel.searchText.toLowerCase();
		var textLength = searchText.length;
		if (textLength > 0) {return false;}
		
		var chartBookId = '';
		var chartId = '';
		if (angular.isDefined($scope.data.id)) chartBookId = $scope.data.id;
		if ((chartBookId === '') && ($scope.viewModel.allowChartMenu)
		&& (angular.isDefined($scope.data.charts[0]))) {
			chartId = $scope.data.charts[0].id;
		}
		if ((chartBookId === '') && (chartId === '')) return;
		var chartRouteParams = angular.extend({}, $routeParams);
		if (angular.isDefined(chartRouteParams.chartBookId)) {
			chartRouteParams.chartBookId = chartBookId;
		}
		SystemRouter.fetchChartHasData(chartBookId, chartId, chartRouteParams).then(function(response) {
			if (angular.isDefined(response.data.charts)) {
				// HasData response may not match the chart array, key an array on chartId
				var chartHasData = [];
				angular.forEach(response.data.charts, function(chart) {
					chartHasData[chart.id] = chart;
				});
				angular.forEach($scope.data.charts, function(chart) {
				
					chart.hasData = chartHasData[chart.id].hasData;
					chart.statusClass = getChartItemClass(chart);
					if (chart.hasData !== 'L') {
						chart.hidden = chartHasData[chart.id].hidden;
					}
					
					angular.forEach(chart.items, function(chartItem) {
						chartItem.statusClass = getChartItemClass(chartItem);
					});
					
				});		
			}
			if (angular.isDefined(response.data.error)) {
				$scope.data.error = response.data.error;
			}
			$scope.data.hasDataLoaded = true;
		});
		
	};
	
	var scrollToChart = function(index) {
		var chartElem = $window.document.getElementById($scope.viewModel.chartHtmlName + '-item-' + index);
		var scrollingDivID = ($mdMedia('xs') ? 'tc_Home-misc-body'
		: ($scope.viewModel.chartHtmlName + '-content'));
		GlobalService.scrollToElement(chartElem, 0, scrollingDivID);
		$scope.data.selectedChartItem = index;
		ElementStateService.set('chartScrollItem', index, angular.toJson($route.current.params));
	};
	
	// Scroll the currently selected chart or chart item so it is at the top
	var scrollToChartMenu = function(chartIndex, chartItemIndex) {
		var chartbookMenuContainer = $window.document.getElementById($scope.viewModel.chartHtmlName + '-menu');
		var chartMenuId = ($scope.viewModel.chartHtmlName + '-menu-' + chartIndex);
		var chartMenu = $window.document.getElementById(chartMenuId);
		
		// Only scroll to a chart item where it is not the first visible item in the chart
		var firstVisibleItemIndex = getNextVisibleItemIndex(chartIndex, -1);
		var chartItemMenu = null;
		if ((angular.isDefined(chartItemIndex)) && (chartItemIndex !== firstVisibleItemIndex)) {
			chartItemMenu = $window.document.getElementById(chartMenuId + '-item-' + chartItemIndex);
		}
		
		// Embedded chart does not reload/scroll the menu to the top on chart/chart item selection
		if ($scope.isEmbedded()) {
			// Don't scroll for the first chart because the menu does not reload in embedded mode
			if (chartIndex !== 0) {
				if (chartItemMenu !== null) {
					if (!GlobalService.isElementInView(chartItemMenu, chartbookMenuContainer)) {
						GlobalService.scrollElementIntoView(chartItemMenu, chartItemMenu, chartbookMenuContainer);
					}
				} else {
					GlobalService.scrollToElement(chartMenu, 0, chartbookMenuContainer);
				}
			}
		} else {
			// Only scroll if the menu is not currently visible
			if (!GlobalService.isElementInView((chartItemMenu ? chartItemMenu : chartMenu), chartbookMenuContainer)) {
				GlobalService.scrollToElement((chartItemMenu ? chartItemMenu : chartMenu), 0, chartbookMenuContainer);
			}
		}
	};
	
	// Show chart menu where multiple charts, or single chart with multiple tabbed items
	var allowChartMenu = function() {
		if (angular.isDefined($scope.data.charts)) {
			if ($scope.data.charts.length > 1) {
				return true;
			} else if ((angular.isDefined($scope.data.charts[0]))
			&& (angular.isDefined($scope.data.charts[0].items))
			&& ($scope.data.charts[0].items.length > 1)
			&& ($scope.data.charts[0].displayInTabs !== '')) {
				return true;
				
			} else if (($scope.data.charts.length === 0)
			&& (angular.isDefined($scope.data.allowChartMenu))) {
				return $scope.data.allowChartMenu;
			}
		}
		return false;
	};
	
	var getChartItemClass = function(item) {
		if (item.hasData == 'L') return 'chartItemHasDataUnknown';
		if (item.hasData == 'U') return 'chartItemHasDataUnknown';
		if (item.hasData == true) return 'chartItemHasData';
		return '';
	};

	// Checks whether the navigation should continue when clicking a chart or chart item menu
	var checkBeforeNavChartItem = function(item) {
		// Trigger the confirm unload service for any components that need to check their dirty state
		WorkflowService.confirmUnloadPrompted = false;
		$rootScope.$broadcast('Workflow:locationChangeStart', item.linkUrl, 0, 0);
		var continueNavigation = !WorkflowService.navigateAwayPrevented;
		WorkflowService.navigateAwayPrevented = false;
		return continueNavigation;
	};
	
	$scope.navChartItem = function($event, item, index) {
		if ((item.linkUrl) && (item.linkUrl != '')) {
			if (!checkBeforeNavChartItem(item)) {
				$event.preventDefault();
				return;
			}
			if (item.customUrl) {
				tkMakeServerCall('epr.Chart','CustomURLExpressionAudit',item.id,item.patientId+'^'+item.episodeId+'^'+item.context);
			}
			// remove the chartScroll Item so it is not used where explicit chartItem is passed in url
			ElementStateService.removeKey('chartScrollItem', angular.toJson($route.current.params));
			if (item.linkUrl == $location.path()) {
				$route.reload();
			} else if (item.linkUrl.indexOf('websys.csp') !== -1) {
				$location.url(item.linkUrl);
			} else if ($scope.isEmbedded()) {
				$scope.reloadChart(item.linkUrl);
			} else {
				var itemUrl = item.linkUrl;
				// when changing chart tabs, remove preserved search (and other user actioned list params like page/sort)
				var currentUrl = $location.url();
				if (currentUrl.indexOf('?') !== -1) {
					itemUrl = itemUrl.split('?')[0] + '?' + currentUrl.split('?')[1];
				}
				var cachedRouteParams = RouteParamsCache.get(itemUrl);
				if ((cachedRouteParams) && (angular.isDefined(cachedRouteParams.TUNIQUELISTPARAMS))) {
					delete cachedRouteParams.TUNIQUELISTPARAMS;
					RouteParamsCache.put(itemUrl, cachedRouteParams);
				}
				WorkflowService.fetchNewChartData = true;
				$location.path(item.linkUrl).replace();
			}
		} else {
			if ($mdMedia('xs')) {
				$scope.toggleMenu();
				// Allow time for the menu to close
				$timeout(function() {
					scrollToChart(index);
				}, 100);
			} else {
				scrollToChart(index);
			}
		}
		$event.stopPropagation();
	};
	
	/// determines if the chart is embeded within some other page, such as ACN, OrderEntry, etc
	$scope.isEmbedded = function() {
		if (angular.isDefined($scope.options.isEmbeddedChart)) return $scope.options.isEmbeddedChart;
		return false;
	};
	$scope.isEmbeddedOrderEntry = function() {
		return ($scope.options.displayMode === 'orderEntry');
	};
	
	/// autohides the menu header toggle toolbar for gt-sm screens
	$scope.defaultMenuHide = function() {
		return ($mdMedia('gt-sm'));
	};
	
	$scope.allowToggleMenu = function() {
		if (!$scope.viewModel.allowChartMenu) return false;
		return ($mdMedia('xs') || $mdMedia('sm'));
	};
	
	$scope.chartbookClick = function() {
		$scope.toggleMenu();
	};
	
	$scope.toggleMenu = function() {
		$scope.viewModel.chartMenuToggled = !$scope.viewModel.chartMenuToggled;
		var toggledStateHidden = (ElementStateService.getPersistant('tcChartbookToggledState') == 'chartMenuHidden');
		ElementStateService.setPersistant('tcChartbookToggledState', 
			!toggledStateHidden ? 'chartMenuHidden' : '');
		$scope.viewModel.chartMenuHidden = 
				(ElementStateService.getPersistant('tcChartbookToggledState') == 'chartMenuHidden');
				
		// Manage Focus
		$timeout(function() {
			var menuHeaderId = $scope.viewModel.chartHtmlName;
			menuHeaderId += ($scope.viewModel.chartMenuHidden ? '-menuVertical' : '-menuHeader');
			var chartMenuElement = $window.document.getElementById(menuHeaderId);
			if (chartMenuElement) chartMenuElement.focus();	
		}, 50);
		
		$scope.$broadcast('Chart:toggleMenu');
	};
	
	// Handle window resizes
	$scope.toggleMenuOnResize = $mdUtil.debounce(function() {
		if ($mdMedia('gt-md')) {
			$scope.viewModel.chartMenuHidden = false;
			$scope.viewModel.chartMenuToggled = false;
		} else if (!$scope.viewModel.chartMenuToggled) {
			// Only toggle menu off when resizing from large and menu has not been toggled by the user
			$scope.viewModel.chartMenuHidden = 
				(ElementStateService.getPersistant('tcChartbookToggledState') == 'chartMenuHidden')
					&& !$scope.viewModel.chartMenuToggled;
		}
	}, 15);
	angular.element($window).on('resize', $scope.toggleMenuOnResize);
	
	$scope.add = function($event, newUrl) {
		$location.url(WorkflowService.getNextLevelUrl(newUrl));
		$event.stopPropagation();
	};

	$scope.openGraphMenu = function($event, graphMenu) {
		var position = {};
		if ($event.target) {
			var rect = $event.target.getBoundingClientRect();
			if (rect) {
				position.left = ((rect.left + rect.width - 250) + 'px');
				position.top = (rect.bottom + 'px');
			}
		}
		$mdDialog.show({
			controller: 'ComponentMenuCtrl',
			templateUrl: 'template/component/componentMenu.html',
			targetEvent: $event,
			clickOutsideToClose: true,
			hasBackdrop: false,
			disableParentScroll: false,
			focusOnOpen: true,
			locals: {
				globalStrings: $scope.globalStrings,
				data: graphMenu,
				position: position,
				componentHtmlName: ''
			}
		});
		
		$event.stopPropagation();
	};
	
	// Can we call child component function instead?
	$scope.layoutEdit = function($event, componentName) {
		$location.url('/LayoutEdit/' + componentName);
		$event.stopPropagation();
	};
	
	$scope.trustUrl = function(url) {
		return $sce.trustAsResourceUrl(url);
	};
	
	$scope.chartClick = function($event, chart) {
		if (chart.customUrl || chart.linkUrl) {
			$scope.navChartItem($event, chart);
		} else {
			chart.collapse = !chart.collapse;
		}	
	};
	
	$scope.chartHeaderClick = function($event, chartItemIndex, chartNestedItemIndex) {
		var chartItem,chartItemHtmlIndex;
		if (angular.isDefined(chartNestedItemIndex)) {
			chartItem = $scope.data.charts[$scope.data.selectedChart].items[chartItemIndex].items[chartNestedItemIndex];
			chartItemHtmlIndex = chartNestedItemIndex;
		} else {
			chartItem = $scope.data.charts[$scope.data.selectedChart].items[chartItemIndex];
			chartItemHtmlIndex = chartItemIndex;
		}
		if (angular.isUndefined(chartItem)) return;
		
		chartItem.collapse = !chartItem.collapse;
		if (!chartItem.collapse) scrollChartContentIntoView(chartItemHtmlIndex);
	};
	
	var scrollChartContentIntoView = function(chartItemIndex) {
		var chartHtmlName = $scope.viewModel.chartHtmlName;
		var chartItemContainer = GlobalService.getScrollableContainer()[0];
		var chartItemContent;
		if (angular.isDefined(chartItemIndex)) {
			chartItemContent = $window.document.getElementById(chartHtmlName + '-item-' + chartItemIndex);
		} else {
			chartItemContent = $window.document.getElementById(chartHtmlName + '-content');
		}
		if (chartItemContainer && chartItemContent) {
			// Execute after the content is visible
			$timeout(function() {
				GlobalService.scrollElementIntoView(chartItemContent, chartItemContent, chartItemContainer);
			});
		}
	};
	
	// Called when selecting a new ChartItem with linkUrl from the ACN. 
	// Allows to reload data for new ChartItem without reloading route
	$scope.reloadChart = function(linkUrl) {
		var params = $route.current.params;
		var urlParams = linkUrl.split('/');
		var chartBookId = urlParams[2];
		var chartId = urlParams[3];
		var chartItemId = urlParams[4];
		ElementStateService.set('embeddedSelectedChart', chartId, angular.toJson($route.current.params));
		ElementStateService.set('embeddedSelectedChartItem', chartItemId, angular.toJson($route.current.params));
		SystemRouter.fetchChartData(chartBookId, chartId, chartItemId, params).then(function(response) {
			initialiseCtrl(response);
		});
	};
	
	// Helper functions for keydown function
	var chartCollapsed = function(index) {
		return $scope.data.charts[index].collapse;
	};
					
	var getNextVisibleChartIndex = function(chartIndex) {
		var foundVisible = false;
		var nextIndex = chartIndex + 1;
		var nextChart = null;
		while ((!foundVisible) && (nextIndex !== chartIndex)) {
			nextChart = $scope.data.charts[nextIndex];
			if (angular.isDefined(nextChart)
				&& (nextChart.searchFilter === 0 || (!nextChart.hidden && !nextChart.searchFilter))) {
				foundVisible = true;
			} else {
				nextIndex = ((nextIndex < ($scope.data.charts.length - 1)) ? nextIndex + 1 : 0);	
			}	
		}
		return (foundVisible ? nextIndex : chartIndex);
			
	};
					
	var getNextVisibleItemIndex = function(chartIndex, itemIndex) {
		var foundVisible = false;
		var nextIndex = itemIndex;
		var chart = $scope.data.charts[chartIndex];
		while ((!foundVisible) && (nextIndex < (chart.items.length - 1))) {
			nextIndex = nextIndex + 1;
			if (chart && chart.items[nextIndex]
				&& (chart.items[nextIndex].searchFilter === 0 
				|| (!chart.items[nextIndex].hidden && !chart.items[nextIndex].searchFilter))) {
				foundVisible = true;
			}
		}
		return (foundVisible ? nextIndex : -1);		
	};
					
	var getPrevVisibleChartIndex = function(chartIndex) {
		var foundVisible = false;
		var prevIndex = chartIndex - 1;
		var prevChart = null;
		while ((!foundVisible) && (prevIndex !== chartIndex)) {
			prevChart = $scope.data.charts[prevIndex];
			if (angular.isDefined(prevChart)
				&& (prevChart.searchFilter === 0 || (!prevChart.hidden && !prevChart.searchFilter))) {
				foundVisible = true;
			} else {
				prevIndex = ((prevIndex > 0) ? prevIndex - 1 : ($scope.data.charts.length - 1));	
			}	
		}
		return (foundVisible ? prevIndex : chartIndex);
	};
					
	var getPrevVisibleItemIndex = function(chartIndex, itemIndex) {
		var foundVisible = false;
		var prevIndex = itemIndex;
		var chart = $scope.data.charts[chartIndex];
		while ((!foundVisible) && (prevIndex > 0)) {
			prevIndex = prevIndex - 1;
			if (chart && chart.items[prevIndex]
				&& (chart.items[prevIndex].searchFilter === 0 
				|| (!chart.items[prevIndex].hidden && !chart.items[prevIndex].searchFilter))) {
				foundVisible = true;
			}
		}
		return (foundVisible ? prevIndex : -1);	
	};
	
	$scope.handleMenuKeydown = function($event, chartOrItem, chartOrItemIndex, isChartItem) {
		// Fire keytips if alt key pressed
		if ($event.altKey) return;
		if ($event.which === tcConstants.KEY_CODE.ENTER) {
			var clickFunction = (!isChartItem ? $scope.chartClick : $scope.navChartItem);
			return clickFunction($event, chartOrItem, chartOrItemIndex);
		}
		if (($event.which === tcConstants.KEY_CODE.UP_ARROW) || ($event.which === tcConstants.KEY_CODE.DOWN_ARROW)) {
			$event.preventDefault();
			$event.stopPropagation();
			if (angular.isDefined($event.target)) {
				var currentElementId = $event.target.id;
				var elementIdPrefix = $scope.viewModel.chartHtmlName + '-menu-';
				var nextElementId = '';
				// ensure this element is a chart menu or one of its children
				if (currentElementId.match(/menu-\d+/)) {
					var chartIndex;
					if (currentElementId.match(/item-\d+/)) {
						var itemIndex = parseInt(currentElementId.split('-item-')[1]);
						chartIndex = parseInt(currentElementId.split('-item-')[0].split('-menu-')[1]);
					} else {
						chartIndex = parseInt(currentElementId.split('-menu-')[1]);	
					}
					
					var nextChartIndex = '';
					var nextItemIndex = '';
					// Find the next matching element
					if ($event.which === tcConstants.KEY_CODE.UP_ARROW) {
						if (angular.isDefined(itemIndex)) {
							nextItemIndex = getPrevVisibleItemIndex(chartIndex, itemIndex);
							if (nextItemIndex === -1) {
								nextElementId = elementIdPrefix + chartIndex; // Up to parent
							} else {
								nextElementId = elementIdPrefix + chartIndex + '-item-' + nextItemIndex; // Up to Prev Item Sibling
							}
						} else {
							nextChartIndex = getPrevVisibleChartIndex(chartIndex);
							if (chartCollapsed(nextChartIndex)) {
								nextElementId = elementIdPrefix + nextChartIndex; // Up to Prev Chart Sibling
							} else {
								var lastChildItemIndex = 
									getPrevVisibleItemIndex(nextChartIndex, $scope.data.charts[nextChartIndex].items.length);
								nextElementId = 
									elementIdPrefix + nextChartIndex + '-item-' + lastChildItemIndex; // Up to last item of Prev Chart Sib
							}
						}
					} else if ($event.which === tcConstants.KEY_CODE.DOWN_ARROW) {
						if (angular.isDefined(itemIndex)) {
							nextItemIndex = getNextVisibleItemIndex(chartIndex, itemIndex);
							if (nextItemIndex === -1) {
								nextChartIndex = getNextVisibleChartIndex(chartIndex);
								nextElementId = elementIdPrefix + nextChartIndex; // Down to Uncle or wrap to Top
							} else {
								nextElementId = elementIdPrefix + chartIndex + '-item-' + nextItemIndex; // Down to next item Sibling
							}
						} else {
							nextChartIndex = getNextVisibleChartIndex(chartIndex);
							if (chartCollapsed(chartIndex)) {
								nextElementId = elementIdPrefix + nextChartIndex; // Down to next chart or wrap to Top
							} else {
								nextItemIndex = getNextVisibleItemIndex(chartIndex, -1);
								nextElementId = elementIdPrefix + chartIndex + '-item-' + nextItemIndex; // Down to first item
							}
						}
					}
					
					// If we have element, focus it
					if (nextElementId !== '') {
						var nextElement = $window.document.getElementById(nextElementId);
						if (angular.isObject(nextElement)) {
							nextElement.focus();
						}	
					}
				}
			}
		}	
	};
	
	/// called for screens that embeds an empty chart shell and need to fetch the chart
	
	$scope.$on('Component:reloadChart', function(event, linkUrl) {
		$scope.reloadChart(linkUrl);
	}); 

	$scope.$on('Global:userLogon', function(event, sessionData) {
		$scope.globalStrings = sessionData.globalStrings;
	});
	
	$scope.$on('Component:componentHeaderClick', function(event, $event, chartItemIndex, chartNestedItemIndex) {
		$scope.chartHeaderClick($event, chartItemIndex, chartNestedItemIndex);
	});
	
	$scope.$on('Component:chartAdd', function(event, $event, chartItemIndex, chartNestedItemIndex) {
		var chartItem = $scope.data.charts[$scope.data.selectedChart].items[chartItemIndex];
		if (angular.isNumber($scope.data.selectedChartItem)) {
			var selectedChartItem = $scope.data.charts[$scope.data.selectedChart].items[$scope.data.selectedChartItem];
			// If selected Chart Item is a Chart Type Item, go to nested Chart Items to get url
			if ((angular.isObject(selectedChartItem)) && (selectedChartItem.itemType == 'CH')) {
				chartItem = selectedChartItem.items[chartNestedItemIndex];
			}
		}
		if (angular.isUndefined(chartItem.newUrl)) return;
		$scope.add($event, chartItem.newUrl);
	});

	$scope.$on('$destroy', function() {
		// cancel any timers that has not yet executed (for case where user browser backs too fast)
		angular.forEach($scope.viewModel.timers, function(timer) {
			$timeout.cancel(timer);
		});
		$scope.viewModel.timers = [];
		angular.element($window).off('resize', $scope.toggleMenuOnResize);
	});
	
	// handler for reinitialising chart on reload
	$scope.$on('Chart:initialise', function(event, chartData) {
		initialiseCtrl(chartData);
	});

	initialiseCtrl(chartData);

});
